import { render, staticRenderFns } from "./KedvezmenyekB15.vue?vue&type=template&id=3fc25735&"
import script from "./KedvezmenyekB15.vue?vue&type=script&lang=js&"
export * from "./KedvezmenyekB15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports